import React from 'react'
import { TrashIcon } from '@heroicons/react/24/outline'
import ExpandyPanel from '~/lib/ui/ExpandyPanel'
import {
  EditorItemField,
  EditorTextArea,
  useEditorItem,
} from './EditorItemProvider'
import { useTranslation } from '~/hooks/useTranslation'

const ReferenceItem = () => {
  const { t } = useTranslation('ReferenceItem')
  const { index, activeIndex, setActiveIndex, deleteItem, item } =
    useEditorItem()

  const headingLabel = item.name ? item.name : t('new_reference')

  const toggleExpanded = () => {
    if (activeIndex == index) {
      setActiveIndex(-1)
    } else {
      setActiveIndex(index)
    }
  }

  const expanded = activeIndex == index
  return (
    <div className="mb-4 flex flex-row items-center">
      <ExpandyPanel
        headingText={headingLabel}
        expanded={expanded}
        index={index}
        onClick={toggleExpanded}
      >
        <div className="grid grid-cols-1 gap-x-6 gap-y-4 md:grid-cols-2">
          <EditorItemField
            containerClassName="md:col-span-2"
            label={t('full_name')}
            fieldName="name"
          />
          <EditorItemField label={t('job_title')} fieldName="positionTitle" />
          <EditorItemField label={t('company_name')} fieldName="companyName" />
          <EditorItemField label={t('phone')} fieldName="phoneNumber" />
          <EditorItemField label={t('email')} fieldName="email" />
          <EditorItemField label={t('address')} fieldName="streetAddress" />
          <EditorItemField
            label={t('city_state_zip')}
            fieldName="cityStateZip"
          />
          <EditorTextArea
            label={t('describe_connection')}
            fieldName="connection"
            containerClassName="md:col-span-2"
          />
        </div>
      </ExpandyPanel>
      {!expanded && (
        <button
          onClick={deleteItem}
          className="max-w-min text-[#b9b9b9]"
          aria-label="remove education"
        >
          <TrashIcon className="ml-2 w-8" />
        </button>
      )}
    </div>
  )
}

export default ReferenceItem
